import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";

import HeaderStats from "components/Headers/HeaderStats";
import ExpensesTypewisetable from "components/Cards/ExpensesTypewisetable";
import UserMessageCountsChart from "components/CardsForMarketing/UserMessageCountsChart";
import NetBalanceChart from "components/NewDashboard/NetBalanceChart";

import { MoveRight } from "lucide-react";
import { apiService } from "lib/apiService";
import StackedBarCategoryChart from "components/NewDashboard/StackedBarCategoryChart";
import AnnualCategoryTrendsChart from "components/NewDashboard/AnnualCategoryTrendsChart";
import ExpenseChatbot from "components/Chatbot/ExpenseChatbot";

export default function Dashboard() {
  const history = useHistory();

  // ✅ Current Date (FIRST define karo)
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  // ✅ States
  const [currency, setCurrency] = useState("");
  const [years, setYears] = useState([]);
  const [selectedGlobalYear, setSelectedGlobalYear] = useState(currentYear);
  const [selectedGlobalMonth, setSelectedGlobalMonth] = useState(currentMonth);

  // ✅ Auth check
  useEffect(() => {
    if (!localStorage.getItem("userData")) {
      history.push("/login");
    }
  }, [history]);

  // ✅ Get user data
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  // ✅ Fetch Years + Currency (FIXED async)
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch years
        const res = await fetch(
          `https://dashboards.workanthem.com/api/available-years?groupId=${groupId}`
        );
        const data = await res.json();
        setYears(data.years || []);

        // Fetch currency
        const fetchedCurrency = await apiService.getCurrency(groupId);
        setCurrency(fetchedCurrency.currency === "INR" ? "₹" : "$");

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (groupId) {
      fetchData();
    }
  }, [groupId]);

  // ✅ Ensure correct default year after API
  useEffect(() => {
    if (years.length > 0) {
      const hasCurrentYear =
        years.includes(currentYear) || years.includes(String(currentYear));

      if (hasCurrentYear) {
        setSelectedGlobalYear(currentYear);
      } else {
        setSelectedGlobalYear(years[0]);
      }
    }
  }, [years, currentYear]);

  return (
    <>
      <Navbar />
      <HeaderStats />

      {/* 🔥 Top Right Button */}
      <div className="flex justify-end pr-4">
        <Link
          to="/expenseDashboard"
          className="flex items-center text-lg text-lightBlue-500 hover:text-lightBlue-700 gap-2 px-3 py-2 rounded-lg transition"
          style={{ textDecoration: "none" }}
        >
          Go to Expense Dashboard
          <MoveRight size={20} />
        </Link>
      </div>

      {/* 🔥 Expense Table */}
      <div className="flex flex-wrap mt-3">
        <div className="w-full px-3">
          <ExpensesTypewisetable years={years} />
        </div>
      </div>

      {/* 🔥 Net Balance Chart */}
      <div className="grid grid-cols-1 mb-6 gap-4 px-3 pt-5">
        <NetBalanceChart
          years={years}
          currency={currency}
          selectedGlobalYear={selectedGlobalYear}
          selectedGlobalMonth={selectedGlobalMonth}
        />
      </div>

      {/* Annual Trends */}
      <div className="grid grid-cols-1 mb-6 gap-4 px-3">
        <AnnualCategoryTrendsChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
      </div>

      {/* Radar + Category */}
      <div className="grid grid-cols-1 mb-6 gap-4 px-3">
        <StackedBarCategoryChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
      </div>

      {/* 🔥 Marketing Chart */}
      <div className="flex flex-wrap mt-3">
        <div className="w-full px-3">
          <UserMessageCountsChart years={years} />
        </div>
      </div>

      {/* <ExpenseChatbot /> */}
      <Footer />
    </>
  );
}